<template>
  <div class="intention_order project_detail">
    <mt-header title="My orders">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    <div class="intention_order_div">
      <!-- <mt-navbar v-model="selected">
        <mt-tab-item id="1">Initiate Order</mt-tab-item>
        <mt-tab-item id="2" >Send Order</mt-tab-item>
      </mt-navbar> -->
      <!-- <mt-tab-container v-model="selected">
        <mt-tab-container-item id="1"> -->
          <ul class="ullist">
            <li v-for="(item,i) in orderData1.list" :key="item.id">
              <div class="strip" @click="downup(i)">
                <div class="exh_img" >
                  <img :src="item.img_url" alt=""/>
                  <button class="confirm confirm1 confirm2" disabled>{{item.status*1?'Confirmed':'unconfirmed'}}</button>
                </div>
                <div class="exh_content">
                  <p>
                    <span class="span1">Exhibitor Name</span>&nbsp;<span class="span2">{{item.corpname_en}}</span><br>
                    <span class="span1">Product Name</span>&nbsp;<span class="span2">{{item.proname_en}}</span>
                  </p>
                </div>
                <div class="xiala">
                  <span :class="orderData1.arrActive[i]*1?'sanjiao_shang':'sanjiao'"></span>
                </div>
              </div>
              <div :class="orderData1.arrActive[i]*1?'down up':'down'">
                <p>
                  <span class="down_span_left">Specification/model</span>
                  <span class="down_span_right">{{item.pro_specification_type}}</span>
                </p>
                <p>
                  <span class="down_span_left">Quantity</span>
                  <span class="down_span_right">{{item.amount}}</span>
                </p>
                <p>
                  <span class="down_span_left">Unit price</span>
                  <span class="down_span_right">{{item.pro_price}}</span>
                </p>
                <p>
                  <span class="down_span_left">Delivery Address</span>
                  <span class="down_span_right">{{item.address}}</span>
                </p>
                <p>
                  <span class="down_span_left">Order Time</span>
                  <span class="down_span_right">{{item.ctime}}</span>
                </p>
              </div>
            </li>
          </ul>
        <!-- </mt-tab-container-item>
        <mt-tab-container-item id="2">
          <ul class="ullist">
            <li v-for="(item1,i) in orderData2.list" :key="item1.ocid">
              <div class="strip" @click="downup1(i)">
                <div class="exh_img1">
                  <img :src="item1.img" alt="">
                  <button class="confirm confirm1 confirm2" :disabled='!item1.status*1'  @click.stop='confirmOrder(item1)'>{{item1.status*1?'已确认':'待确认'}}</button>
                </div>
                <div class="exh_content1">
                  <p>
                    <span class="span2">{{item1.name?item1.name:item1.nickname}}</span><br>
                    <span class="span2">{{item1.corpname}}</span>
                  </p>
                </div>
                <div class="xiala">
                  <span :class="orderData2.arrActive[i]*1?'sanjiao_shang':'sanjiao'"></span>
                </div>
              </div>
              <div :class="orderData2.arrActive[i]*1?'down up':'down'">
                <p>
                  <span class="down_span_left">Product Name</span>
                  <span class="down_span_right">{{item1.proname_cn}}</span>
                </p>
                <p>
                  <span class="down_span_left">Quantity</span>
                  <span class="down_span_right">{{item1.amount}}</span>
                </p>
                <p>
                  <span class="down_span_left">Tel</span>
                  <span class="down_span_right">{{item1.mobile}}</span>
                </p>
                <p>
                  <span class="down_span_left">Email</span>
                  <span class="down_span_right">{{item1.email}}</span>
                </p>
                <p>
                  <span class="down_span_left">Delivery Address</span>
                  <span class="down_span_right">{{item1.address}}</span>
                </p>
                <p>
                  <span class="down_span_left">Order Time</span>
                  <span class="down_span_right">{{item1.ctime}}</span>
                </p>
              </div>
            </li>
          </ul>
        </mt-tab-container-item>
      </mt-tab-container> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Header } from 'mint-ui';
import { Toast } from 'mint-ui';
import { reqMyOrderTo, reqMyOrderGet, reqMyOrderStatus } from "../../../../api";
export default {
  components:{
    'mt-header':Header
  },
  data(){
    return{
      selected:'1',
      arrActive:[],
      orderData1:{list:[],arrActive:[]},
      orderData2:{list:[],arrActive:[]},
    }
  },
  mounted(){
    this.initHair()
    this.initReceived()
  },
  methods:{
    downup(i){
      // console.log(i);
      if(this.orderData1.arrActive[i]){
        this.$set(this.orderData1.arrActive,i,0)
      }else{
        this.$set(this.orderData1.arrActive,i,1)
      }
    },
    downup1(i){
      // console.log(i);
      if(this.orderData2.arrActive[i]){
        this.$set(this.orderData2.arrActive,i,0)
      }else{
        this.$set(this.orderData2.arrActive,i,1)
      }
    },
    async initHair(){
      const response = await reqMyOrderTo()
      // console.log(response);
      if (response.code*1==2) {
        // this.orderData1.list=response.reslist
        this.sorting(response.reslist,0)
      }
    },
    async initReceived(){
      const response = await reqMyOrderGet()
      // console.log(response);
      if (response.code*1==2) {
        // this.orderData1.list=response.reslist
        this.sorting(response.reslist,1)
      }
    },
    sorting(arr,key){
      console.log(arr);
      arr.forEach(item => {
        if (!item.pro_price) {
          item.pro_price='Negotiate'
        }
        if (!item.name) {
          item.name=item.nickname
        }
      });
      if (key) {
        this.orderData2.list=arr
      }else{
        this.orderData1.list=arr
      }
    },
    async confirmOrder(item){
        const response = await reqMyOrderStatus(item.id)
        if (response.code*1==3) {
          Toast({position: 'top',message: 'Confirmed'})
          this.initReceived()
        }else{
          Toast({position: 'top',message: 'Timeout, please try...'})
        }
    }
  },
  computed:{
    ...mapState({
      user:state=>state.user.user,
    })
  },
}
</script>
<style scoped>
.intention_order{
  height: 100%;
}
.intention_order_div{
  height: calc(100% - 40px);
  max-height: calc(100% - 40px);
  overflow: auto;
}
.intention_order>>>.mint-navbar .mint-tab-item.is-selected{
  border-bottom-color: #008baf;
  color: #008baf;
}
.ullist{
  padding-bottom: 10px;
}
.ullist li{
  margin-top: 10px;
  box-shadow: 1px 1px  4px rgb(194, 194, 194);
}
.strip{
  display: table;
  padding: 10px;
  background-color: white;
  /* box-shadow: 1px 2px  2px rgb(194, 194, 194); */
  width: 100%;
}
.exh_img{
  display: table-cell;
  width: 80px;
}
.exh_img1{
  width: 44px;
}
.exh_img>img,
.exh_img1>img{
  height: auto;
}
.exh_img>button,
.exh_img1>button{
  display: inline-block;
  width: 100%;
  padding: 4px ;
  border: none ;
  font-size: 12px;
  color: #008baf;
  background-color: #c4e9f388;
}
.exh_content{
  display: table-cell;
  padding: 0 10px ;
  padding-left: 70px;
  width: calc(100% - 100px);
  font-size: 12px;
  vertical-align: middle;
}
.exh_content1{
  display: table-cell;
  padding: 0 10px ;
  /* padding-left: 70px; */
  width: 300px;
  font-size: 12px;
  vertical-align: middle;
}

.exh_content p{
  height: 100%;
  /* vertical-align: middle; */
}
.exh_content .span1{
  margin-left: -60px;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
}
.span2{
  line-height: 22px;
}

.xiala{
  display: table-cell;
  width: 20px;
}
.sanjiao{
  margin-bottom: -10px;
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #bfbfbf;
  border-bottom: 10px solid transparent;
}
.sanjiao_shang{
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid transparent;
  border-bottom: 10px solid #bfbfbf;
}

.down{
  display: none;
  font-size: 12px;
  color: #666666;
  background-color: #f2f2f2;
  padding: 10px;
}
.up{
  display: block;
}
.down_span_left{
  display: inline-block;
  width: 120px;
  text-align: end;
}
.down_span_right{
  padding-left: 10px;
  line-height: 22px;
  
}

</style>